import './Checkout.scss'
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Button, Col, Container, Placeholder, Row} from "react-bootstrap";
import {useContext, useEffect, useRef, useState} from "react";
import AppContext from "../AppContext";
import {useParams} from "react-router-dom";
import API, {HandleError} from "../API";
import {useSnackbar} from "notistack";
import {Order} from "../models/Order";
import {
    MdOutlineCheckCircleOutline,
    MdOutlineErrorOutline,
    MdOutlinePending
} from "react-icons/md";
import {useTranslation} from "react-i18next";

export default function OrderStatus() {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(true)
    const [order, setOrder] = useState(null)

    const { order_id } = useParams();
    const statusTimer = useRef(null)
    useEffect(() => {
        getOrder()
    }, [])
    useEffect(() => {
        statusTimer.current = setTimeout(() => {
            if(order && !order.is_pending) {
                if(order.is_paid) {
                    //console.log('PAID')
                }
                return;
            }
            getOrder()
        }, 5000)
        return () => clearTimeout(statusTimer.current)
    }, [order])
    const getOrder = async () => {
        try {
            const res = await API({
                method: 'GET',
                url: `/order/${order_id}`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                }
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            setOrder(new Order(res.data.item))
        }
        catch(e) {
            setLoading(false)
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <div id="page-order-status" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container style={{maxWidth: 800, textAlign: "center"}}>
                <h1 className="text-center title">{t('paymentStatus.title')}</h1>
                <h3 className="text-center text-muted">

                </h3>
                <div className="pricing-section mt-5">
                    <Row className="card-deck mb-3 text-left">
                        <Col md={12} style={{maxWidth: 600}} className="ms-auto me-auto">
                            <div className="card mb-4">
                                <div className="card-header py-3">
                                    <h4 className="my-0">{t('paymentStatus.order')}: #{order?.ID}</h4>
                                </div>
                                <div className="card-body text-center py-4">
                                    {order ? <div className="">
                                            {order?.is_pending ? <p className="fw-bold fs-5 text-info">
                                                <MdOutlinePending size={64} opacity={0.4} /><br />{t('paymentStatus.pending')}
                                            </p> : <></>}
                                            {!order?.is_pending && !order?.is_paid ? <div>
                                                <p className="fw-bold fs-5 text-danger">
                                                    <MdOutlineErrorOutline size={64} opacity={0.4} /><br />{t('paymentStatus.failed')}: {order?.status?.toUpperCase()}
                                                </p>
                                                <Button className="mt-4" href={`/checkout/${order.plan_id}`} variant="secondary">{t('paymentStatus.tryAgain')}</Button>
                                            </div>: <></>}
                                            {order?.is_paid ? <div><p className="fw-bold fs-5 text-success">
                                                <MdOutlineCheckCircleOutline size={64} opacity={0.4} /><br />{t('paymentStatus.successful')}
                                            </p>
                                                {order.is_activated ? <Button className="mt-4" href="/" variant="success">
                                                    {t('button.continue')}
                                                </Button> : <Button className="mt-4" href="/account#orders" variant="success">
                                                    {t('button.activate')}
                                                </Button>}
                                            </div> : <></>}
                                        </div> : <>
                                        <Placeholder as="h1" bg="light">
                                            <Placeholder xs={12} />
                                        </Placeholder>
                                    </>}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    </div>
}